import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Store from '../views/Store.vue'
import Vote from '../views/Vote.vue'
import Hiscores from '../views/Hiscores.vue'
import Discord from '../views/Discord.vue'
import PlayersOnline from '../views/PlayersOnline.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/store',
    name: 'Store',
    component: Store
  },
  {
    path: '/vote',
    name: 'Vote',
    component: Vote
  },
  {
    path: '/hiscores',
    name: 'Hiscores',
    component: Hiscores
  },
  {
    path: '/discord',
    name: 'Discord',
    component: Discord
  },
  {
    path: '/PlayersOnline',
    name: 'PlayersOnline',
    component: PlayersOnline
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkExactActiveClass: "active" // active class for *exact* links.
})

export default router
